import {
    RESET_PASSWORD,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILURE,
} from './constants';

/**
 *
 * @param formData
 * @param resolve
 * @param reject
 * @returns {{reject: *, resolve: *, formData: *, type: string}}
 */
const resetPassword = (formData, resolve, reject) => ({
    type: RESET_PASSWORD,
    formData,
    resolve,
    reject,
});

/**
 *
 * @param obj
 * @returns {{type: string, obj: *}}
 */
const resetPasswordSuccess = (obj) => ({
    type: RESET_PASSWORD_SUCCESS,
    obj
});

/**
 *
 * @param errors
 * @returns {{errors: *, type: string}}
 */
const resetPasswordFailure = (errors) => ({
    type: RESET_PASSWORD_FAILURE,
    errors
});

export {
    resetPassword,
    resetPasswordSuccess,
    resetPasswordFailure,
};